import { combineReducers } from 'redux'
import { debateReducer } from 'modules/debate'
import { userReducer } from 'modules/user'
import { REHYDRATE } from 'redux-persist/constants'
import { createReducer } from 'modules/util'

import ActionType from '../actionTypes'

const appReducer = combineReducers({
  debate: debateReducer,
  user: userReducer,
  persist: createReducer({ rehydrate: false }, {})
})

export default function rootReducer(state, action) {
  if (action.type === ActionType.RESET_STATE) {
    return appReducer(undefined, action)
  }

  if (action.type === REHYDRATE) {
    return appReducer(
      { ...state, ...action.payload.app, persist: { rehydrate: true } },
      action
    )
  }

  return appReducer(state, action)
}



// WEBPACK FOOTER //
// ./client/modules/app/reducer/index.js